import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// Temporarily handed back to Ember while the Hydra login regression is fixed
// (FPS-2523). @/pages/academy-login.page is intact but unreachable.
export const Route = createFileRoute('/academy-login')({
  component: JourneysLegacyAuthRefreshRoute,
});
